import keyBy from 'lodash-es/keyBy';
import { ISeverityCountType } from 'src/common/components/mobile-scans-impacted-by-severity-chart/MobileScansImpactedBySeverityChart';
import { MOBILE_ISSUE_SEVERITY_LIST } from 'src/common/helpers/MobileQueriesHelper';

import { MfaSessionSeveritiesQuery } from '../MfaSessionSeverities.generated';

export const transformMfaSessionSeveritiesResults = (
	rawResults: MfaSessionSeveritiesQuery
): ISeverityCountType[] => {
	const issuesBySeverity = rawResults.mfa_test_by_severity || [];
	const scansBySeverity = rawResults.mfa_scans_impacted_per_issue_severity || [];

	const issuesMap = keyBy(issuesBySeverity, 'severity_name');
	const scansMap = keyBy(scansBySeverity, 'severity_name');

	return (
		MOBILE_ISSUE_SEVERITY_LIST.map(({ key, name }) => ({
			id: key,
			name,
			severity: key,
			count: issuesMap[key]?.total_issues ?? 0,
			scanCount: scansMap[key]?.total_scans ?? 0
		}))
			// Keep only severities that have issues
			.filter((severityObj) => severityObj.count > 0)
	);
};
